import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'REGISTER_VIEW', {
  TITLE: 'Register',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'REGISTER_VIEW', {
  TITLE: 'Registrarse',
  LOADING: 'Cargando...',
});
